import React from 'react';

import { IconAudioFileAIF, IconAudioFileMP3, IconAudioFileWAV } from '../icons';

interface IconMap {
    aif: IconComponent;
    aiff: IconComponent;
    mp3: IconComponent;
    wav: IconComponent;
}

type IconMapKey = keyof IconMap;

const iconMap = {
    aif: IconAudioFileAIF,
    aiff: IconAudioFileAIF,
    mp3: IconAudioFileMP3,
    wav: IconAudioFileWAV,
} as IconMap;

export const getAudioFileIcon = (filename: string): IconComponent => {
    const extensionMatch = filename.match(/.(\w+)$/);
    const emptyResult = (): JSX.Element => <div />;

    if (extensionMatch !== null) {
        const extension = extensionMatch[1].toLowerCase() as IconMapKey;

        if (iconMap[extension]) {
            return iconMap[extension];
        }
    }

    return emptyResult;
};
